import { Auth } from 'aws-amplify';

const Logout = (to, from, next) => {
  let isLogoutPage = (to.name == 'logout');

  if (isLogoutPage) {
    Auth.signOut()
      .then((user) => {
        console.log('Signing out...');
        window.close();
      })
      .catch((err) => {
        console.log('Unable to log out', err);
        window.close();
        next('/');
      });
  } else {
    next();
  }
};

export default Logout;
